export function getTimezoneName(date = new Date()) {
  let timeZone: string;
  try {
    timeZone = date
      .toLocaleTimeString('en-us', { timeZoneName: 'short' })
      .split(/\s/g)
      .pop()!;
  } catch (e) {
    timeZone = 'EST';
  }
  return timeZone;
}
